import { colors } from "@indeed/ifl-tokens";
import React from "react";
import { StyleSheet, type ViewStyle } from "react-native";

import { Box, Tag, TagDot, Text } from "../../../../../../mads";

export type InterviewNowFlairProps = {
  displayText: string;
  containerStyle?: ViewStyle;
};

// Custom implementation for Tag because Tag component was not handling spacing for TagDot and Text
const styles = StyleSheet.create({
  container: {
    alignItems: "flex-start",
  },
  tagContainer: {
    flexDirection: "row",
    alignItems: "center",
  },
  text: {
    color: colors.neutral[0],
    fontWeight: "bold",
    marginLeft: 6,
  },
});

export const InterviewNowFlair: React.FC<InterviewNowFlairProps> = ({
  displayText,
  containerStyle,
}) => {
  return (
    <Box sx={[containerStyle, styles.container]}>
      <Tag variant="solid" status="success">
        <Box sx={styles.tagContainer}>
          <TagDot variant="solid" />
          <Text level={2} sx={styles.text}>
            {displayText}
          </Text>
        </Box>
      </Tag>
    </Box>
  );
};
